var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.541992 2.66661V5.91661M0.541992 5.91661H3.79199M0.541992 5.91661L3.05533 3.55494C3.63748 2.97249 4.35769 2.54701 5.14876 2.31819C5.93983 2.08937 6.77598 2.06468 7.57917 2.24641C8.38236 2.42815 9.12643 2.81038 9.74195 3.35746C10.3575 3.90453 10.8244 4.59861 11.0991 5.37494M12.4587 11.3333V8.08327M12.4587 8.08327H9.20866M12.4587 8.08327L9.94533 10.4449C9.36317 11.0274 8.64296 11.4529 7.85189 11.6817C7.06082 11.9105 6.22467 11.9352 5.42148 11.7535C4.61829 11.5717 3.87422 11.1895 3.2587 10.6424C2.64319 10.0953 2.17629 9.40126 1.90158 8.62494",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.55539ae2a0c9e079f8ac2f3410eff2df.svg";
export { ForwardRef as ReactComponent };